import React from 'react';
import Row from "../../../SDFormTemplate/Row";
import Section from '../../../SDFormTemplate/Section';
import Accordion from 'components/Common/Accordion/Accordion';

function Reports({ setInvalidConditions, setFormData }) {
  
  const title = 'Reports';

  const REPORTS_OPTIONS_ENDPOINT = `/ServiceDesk/getReportsOptions`

  const reportsSection = ([
    <div key='reports_description'>
      <p style={{ fontWeight: '600' }}>Apply following reports to:</p>
      <Section
        key='reports_toggle_section'
        title='reports_group_setting'
        type='customToggle'
        toggleLeftlabel='Root Group'
        toggleRightLabel='All Groups'
        toggleLeftValue='root'
        toggleRightValue='all'
        setInvalidConditions={setInvalidConditions}
        setFormData={setFormData}
      />
    </div>,
    <Section
      key='reports_options_section'
      title='reports'
      altTitle='Reports'
      type='dropdown'
      isMulti
      placeholder='Select reports to use...'
      inlineWrapperStyles={{ minHeight: '350px' }}
      valueType='array'
      mapFromEndpoint={{ endpoint: REPORTS_OPTIONS_ENDPOINT, dispatch: false }}
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
    />,
  ])

  return (
    <div key="reports">
      <Row
        key='row_6'
        sections={[
          (index) => (
            <Accordion
              key='accordion_6'
              title={title}
              accordionHeaderSection={true}
              accordionHeaderContents={{
                size: 'md',
                message: 'Select from our automated compliance reports and apply to all groups or solely at the dashboard.',
              }}
              showNumberInHeader={false}
              headerNumber={index + 1}
              content={[
                reportsSection,
              ]}
            />
          )
        ]}
      />
    </div>
  )
}

export default Reports;
